import styled, {keyframes} from 'styled-components';
import store from "../config/config.json"

const strokeDraw = keyframes`
  from{
    stroke:${store.primaryDarkColor};
    stroke-dasharray: 1;
  }
  to{
    stroke:${store.primaryColor};
    transform:rotate(180deg);
    stroke-dasharray: 8;
  }
`

export const StoryWrapper = styled.div`
  position:relative;
  width:100px;
  height:100px;
  svg {
    enable-background:new -580 439 577.9 194;
    fill:none;
    stroke:#8a3ab9;
    stroke-linecap: round;
    stroke-width:3;
    stroke-dasharray: 1;
    stroke-dashoffset: 0;
    animation: ${strokeDraw} 6s ease-out infinite alternate; 
  }
  img {
    position:absolute;
    left:50%;
    top:50%;
    transform:translate(-50%, -50%);
    width:70px;
    border-radius:50%;
  }
`;

